export default __webpack_public_path__ + "2432ef002ed98cc9c868b915fccb2f43.svg";